export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-slider-bar/index.js